import { useState } from 'react';
import Header from './fragment-sys/header.js';
import Navi from './fragment-sys/navi.js';
import Footer from './fragment-sys/footer.js';
import '@assets/css/system.css';
import '@assets/css/sys-content.css';

const SysLayout = ({ children }) => {
	const [title, setTitle] = useState(() => sessionStorage.getItem('page::title') || '');
	const [breadcumb, setBreadcumb] = useState(() => sessionStorage.getItem('page::breadcumb') || '');

	const handleChildChange = (item, parentMenu) => {
		setTitle(item.label);
		setBreadcumb(parentMenu + ' > ' + item.label);
		sessionStorage.setItem('page::path', item.to);
		sessionStorage.setItem('page::title', item.label);
		sessionStorage.setItem('page::breadcumb', parentMenu + ' > ' + item.label);
	};

	return (
		<>
			<Header />
			<Navi onChange={handleChildChange}/>
			<main>
				<div className="container-fluid mt-2">
					{/* Page Title */}
					<div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1">
						<h1 className="h2">{title}</h1>
					</div>
					<div className="bd-example-snippet bd-code-snippet mb-3" style={{backgroundColor: "#cfe2ff"}}>
						<div className="bd-example m-0 border-0 p-2">
							<nav aria-label="breadcrumb">
								<ol className="breadcrumb mb-0">
									<li className="breadcrumb-item">Home {'>'} {breadcumb}</li>
								</ol>
							</nav>
						</div>
					</div>

					{/* Page Content */}
					{children}
					<Footer />
				</div>
			</main>
		</>
	);
};

export default SysLayout;